module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("Primary colors")]), _vm._v(" "), _vm._l((_vm.primaryColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box type1"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc mt--bg--neutrals-light-gray-01",
      class: color.color
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('h2', [_vm._v("Secondary colors")]), _vm._v(" "), _vm._l((_vm.SecondaryColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box type1"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc mt--bg--neutrals-light-gray-01",
      class: color.color
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('h2', [_vm._v("Neutrals")]), _vm._v(" "), _vm._l((_vm.Neutrals), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box type1"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc mt--bg--neutrals-light-gray-01",
      class: color.color
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('h2', [_vm._v("Extended colors")]), _vm._v(" "), _vm._l((_vm.PrimaryExtendedColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box color-box--type2"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.SuccessExtendedColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box color-box--type2"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.ErrorExtendedColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box color-box--type2"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.WarningExtendedColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box color-box--type2"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.InfoExtendedColors), function(color) {
    return _c('div', {
      key: color.name,
      staticClass: "color-box color-box--type2"
    }, [_c('div', {
      staticClass: "color",
      class: color.color + ' mt--' + color.color + ' mt--bg--' + color.color
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('ul', [_c('li', {
      staticClass: "name mt--black"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("HEX")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.hex))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "label"
    }, [_vm._v("RGB")]), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(color.rgb))])])])]), _vm._v(" "), _c('div', {
      staticClass: "usage mt--neutrals-dark-gray-01"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(color.usage) + "\n\t\t\t")])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Colors")]), _vm._v(" "), _c('span', [_vm._v("Product")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b85f6490","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Colors.vue
// module id = R0KL
// module chunks = 0